import React from 'react'
import ProdIOOSumViewRow from './ProdIOOSumViewRow'
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOSumView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="Stock Actions" /></span>
                    </UiTitle>
                    <UiAction>
                        <span className="uiSpacerH5"><SarasTrans value="Step 1: Add Stock" /></span>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            confirm="Do you want to Autogenerate?"
                            action={{ actionId: "new", 
                            paramName: "autoGeneratePlanBtn",
                            actionParam: {actionType : "autoGeneratePlanItems", pathKey:"OEXI"}, 
                            refreshMode:"self", excludePathKeys: 1 }}
                            text={<SarasTrans value="Auto Generate Plan" />}>
                        </FormButton>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton "
                            action={{ actionId: "new", 
                            paramName: "addBOMBtn",
                            actionParam: {actionType : "addBOMItem", pathKey:"OEXI", 
                            viewKey:"addBOMItem"}, 
                            containerKey: "popup"
                            }}
                            text={<SarasTrans value="Add Stock from BOM" />}>
                        </FormButton>
                        <div className="uiSpacerH10"></div>
                        <FormWrapper customWrapper="" formObject={formObject} 
                            headerKey="viewConfig" action={{ paramName: "addAdhocBtn" }} >
                            <FormSearchButton formObject={formObject} headerKey='lineItemLink'
                                action={{ actionId: "new", 
                                loadEditorAfterAdd: 1,
                                actionParam: {actionType : "addItem", pathKey: "OEXI"}, 
                                refreshMode:"self", excludePathKeys: 1 }}
                                className='uiActionIconButton uiSpacerH10' placeholder="Barcode or Item Id"
                            />
                        </FormWrapper>
                        <div className="uiSpacerH10"></div>
                        <span className="uiSpacerH5"><SarasTrans value="Step 2: Inventory Action" /></span>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new", 
                            paramName: "addReqStkBtn",
                            actionParam: {actionType : "requestItem", pathKey:"OREQ", viewKey:"addRequest"}, 
                            containerKey: "popup" }}
                            text={<SarasTrans value="Request Stock" />}>
                        </FormButton>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new",
                            paramName: "addRetStkBtn", 
                            actionParam: {actionType : "returnInput", pathKey:"ORET", viewKey:"addReturn"}, 
                            containerKey: "popup" }}
                            text={<SarasTrans value="Return Stock" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Required" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Allocated" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Requested" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Received" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Iss To Worker" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Ret By Worker" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Consumed" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Wasted" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Bal" /></li>
                                <li className="uiColumnCenter uiColumnQty"><SarasTrans value="Qty Ret To Stock" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                                <li><ProdIOOSumViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOSumView, "prodIOSum", "prodIOSum");